import React from 'react';
import { useTranslation } from 'react-i18next';
import CollapseAnimation from 'components/atoms/base-animations/collapse';

import s from './styles.module.scss';

interface IProps {
  label: string;
  opened: boolean;
  children?: React.ReactNode;
  onChange: () => void;
}

const SmsDashboardProfileInfoDropDown: React.FC<IProps> = ({
  label,
  opened,
  children,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s.dropdown}>
      <div className={s.title}>
        {label}
        <button onClick={onChange}>
          {opened ? t('smsDashboard.less') : t('smsDashboard.more')}
        </button>
      </div>

      <CollapseAnimation opened={opened}>{children}</CollapseAnimation>
    </div>
  );
};

export default SmsDashboardProfileInfoDropDown;
